module.exports = __webpack_public_path__ + "img/IT0000474312425.8b6363fb.png";